__webpack_require__.p = "/MineObserver-2.0/";